import * as Cookies from "es-cookie"
import store from "./store"
import { setError } from "actions"
import { DLogin } from "apis/DLogin"
import { getJWToken } from "apis/JWToken"
import { DLogout } from "apis/DLogout"
import { moveToTop } from "locale"

export const handleAuthentication = async () => {
  if (!window.location.search) {
    moveToTop()
  } else {
    // codeの存在チェック＆state値の合致チェック
    const paramArray = window.location.search.substring(1).split("&")
    const code = paramArray.find((param) => {
      return !param.indexOf("code=")
    })

    const uriAuthState = paramArray.find((param) => {
      return !param.indexOf("state=")
    })
    const cookieAuthState = Cookies.get("authStateToken")
    Cookies.remove("authStateToken")

    const cookieNonce = decodeURIComponent(Cookies.get("nonce"))
    Cookies.remove("nonce")

    const targetUrl = decodeURIComponent(uriAuthState).slice(22)
    if (
      code &&
      code.slice(5) &&
      uriAuthState &&
      cookieAuthState === uriAuthState.slice(6)
    ) {
      // チェックOKの場合、cookieに保存されたstateを削除し、getTokenAPIを叩く
      const codeValue = code.slice(5)

      const { payload, error } = await getJWToken(codeValue)
      if (payload && !error) {
        if (checkNonce(payload.nonce, cookieNonce)) {
          Cookies.set("JWToken", payload.token, { secure: true })
          window.history.replaceState({}, document.title, targetUrl)
          window.location.reload()
        } else {
          DLogout()
        }
      } else {
        switch (Math.floor(error.status / 100)) {
          case 4:
            // ここのあるべきを考える必要あり
            // コールバック画面にてエラーを表示した上で、数秒後にDLoginに遷移とかが良さそう。
            DLogin({ prompt })
            break
          default:
            moveToTop()
            store.dispatch(setError())
            break
        }
      }
    } else {
      moveToTop()
      store.dispatch(setError())
    }
  }
}

const checkNonce = (nonce, cookieNonce) => {
  if (nonce && cookieNonce && nonce === cookieNonce) {
    return true
  } else {
    return false
  }
}
